'use client'

import dynamic from 'next/dynamic'
import { useResponsiveVariant } from '@/utils/useResponsiveVariant'

const ContactUs = dynamic(
  async () => {
    const { ContactUs } = await import('./ContactUs')
    return ContactUs
  },
  { ssr: false },
)

export function ContactUsDynamic() {
  const variant = useResponsiveVariant('lg')
  if (variant !== 'desktop') return null
  return <ContactUs />
}
